import { buildApiUrl } from '../config/api.js';

class VehicleModelService {
  constructor() {
    this.authenticatedFetch = null;
  }

  // Método para establecer la función de fetch autenticada
  setAuthenticatedFetch(fetchFn) {
    this.authenticatedFetch = fetchFn;
  }

  // Obtener todos los modelos de vehículos
  async getAllVehicleModels() {
    try {
      const url = buildApiUrl('/api/admin/vehicle-models');
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener modelos de vehículos:', error);
      throw error;
    }
  }

  // Obtener modelo por ID
  async getVehicleModelById(id) {
    try {
      const url = buildApiUrl(`/api/admin/vehicle-models/${id}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al obtener modelo de vehículo:', error);
      throw error;
    }
  }

  // Crear nuevo modelo
  async createVehicleModel(modelData) {
    try {
      const url = buildApiUrl('/api/admin/vehicle-models');
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(modelData)
          })
        : await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(modelData)
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al crear modelo de vehículo:', error);
      throw error;
    }
  }

  // Actualizar modelo
  async updateVehicleModel(id, modelData) {
    try {
      const url = buildApiUrl(`/api/admin/vehicle-models/${id}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(modelData)
          })
        : await fetch(url, {
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            },
            body: JSON.stringify(modelData)
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al actualizar modelo de vehículo:', error);
      throw error;
    }
  }

  // Eliminar modelo
  async deleteVehicleModel(id) {
    try {
      const url = buildApiUrl(`/api/admin/vehicle-models/${id}`);
      
      const response = this.authenticatedFetch 
        ? await this.authenticatedFetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json'
            }
          })
        : await fetch(url, {
            method: 'DELETE',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${localStorage.getItem('authToken')}`
            }
          });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(`Error ${response.status}: ${errorData.message || response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error al eliminar modelo de vehículo:', error);
      throw error;
    }
  }
}

export default new VehicleModelService();
